<template>
  <div>
    <b-table-simple borderless style="">
        <b-tbody>
            <b-tr v-if="fileUrl" style="text-align: left" :class="{
          'd-print-block': exportAttachment,
          'd-print-none': !exportAttachment,
      }">
                <b-td class="p-0">
                    <div class="container-title mb-3">Lampiran</div>
                    <div v-if="fileExtension === 'pdf'"><a :href="fileUrl">Nota Bongkar.{{fileExtension}}</a></div>
                    <img v-else :src="fileUrl" alt="attachment" style="max-height: 10cm"/>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
    <b-table-simple borderless class="d-none d-print-table">
        <b-tbody>
          <b-tr>
            <b-td>{{ lodash.upperFirst($t('sale_notes.resumes.acknowledged_by')) }}</b-td>
          </b-tr>
          <b-tr>
            <b-td><img  :src="`${publicPath}/brs-sign-v2.png`" :alt="$t('sale_notes.resumes.sign')" style="height: 50px"/></b-td>
          </b-tr>
          <b-tr>
            <b-td>Gilang Maulana</b-td>
          </b-tr>
          <b-tr style="text-align: center">
            <b-td><span style="border-top: 1px solid">Operation Admin Lead</span></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
  </div>
</template>

<script>
export default {
  name: 'sign-export',
  props: {
    fileUrl: {type: String, default: null},
    fileExtension: {type: String, default: null},
    files: {type: Array, default: () => []},
    exportAttachment: {type: Boolean, default: false}
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_URL
    }
  }
}
</script>

<style scoped>
table {
  page-break-inside: avoid;
  th, td {
    padding: 4px;
  }
}
</style>